<template>
  <div class="m-pop-layer">
    <div class="m-flex-row">
      <div class="m-pop-content cicc">
        <div class="m-pop-res" v-if="payResult === 'success'">
          <img src="../../assets/icons/success.png" class="m-pop-icon" />
          <p class="m-pop-title-cicc">支付成功</p>
          <p class="m-pop-des-cicc">恭喜您，已成功完成支付</p>
        </div>
        <div class="m-pop-res" v-else-if="payResult === 'warning'">
          <img src="../../assets/icons/warning.png" class="m-pop-icon" />
          <p class="m-pop-title-cicc">支付超时</p>
          <p class="m-pop-des-cicc">订单超时，请重新支付</p>
          <p class="m-pop-btn-cicc" @click="rePay">重新支付</p>
        </div>
        <div class="m-pop-res" v-else-if="payResult === 'fail'">
          <img src="../../assets/icons/fail.png" class="m-pop-icon" />
          <p class="m-pop-title-cicc">支付失败</p>
          <p class="m-pop-des-cicc" v-if="failReason.length">
            失败原因：{{ failReason || "" }}
          </p>
          <p class="m-pop-btn-cicc" @click="rePay">重新支付</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "pay-finish-cicc",
  props: ["payResult", "failReason"],
  methods: {
    rePay: function () {
      this.$emit("rePay");
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// pay-finish-cicc.vue?5a9c876c